<div class="container pb-2">
    <h1 class="text-uppercase">{{channel}} Channel </h1>
    <h2 class="text-uppercase">{{productId}}</h2>
    <app-device-list [devices]="devices" [availableChannels]="availableChannels"
        (rechannel)="rechannel($event)" (filterChanged)="loadWithFilter($event)"></app-device-list>
    <button href="" class="btn btn-primary" (click)="loadMore()" [class.disabled]="!nextToken">Load More</button>
</div>